import { chakra } from '@stockx/ui';

export const DropdownMenu = chakra('ul', {
  baseStyle: {
    position: 'absolute',
    top: '100%',
    left: { md: '-78px', xl: '-100px' },
    zIndex: 1000,
    float: 'left',
    padding: 0,
    margin: 0,
    boxShadow:
      '0px 4px 4px rgba(0, 0, 0, 0.25), 0px -2px 4px rgba(0, 0, 0, 0.1)',
    width: { md: '115px', lg: '132px', xl: '160px' },
    border: 'none',
    fontWeight: 600,
    color: 'neutral.700',
    listStyle: 'none',
    backgroundColor: 'neutral.white',
    backgroundClip: 'padding-box',
  },
});
